'use strict';

var IPreferencesManager = function(){};

IPreferencesManager.prototype = { // Interface
    setPreference: function(name, value){},
    getPreference: function(name){},
    deletePreference: function(name){}
};

module.exports = IPreferencesManager;


//////////////////
// WEBPACK FOOTER
// ./mits/Storage/IPreferencesManager.js
// module id = 15
// module chunks = 0